import * as type from "../types";

const initialState = {
    mapToBounds: null,
    mapFitBounds: null,
    mapManuallyMoved: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.MAP_FIT_BOUNDS:
            return {
                ...state,
                mapToBounds: action.value,
            };
        case type.MAP_FIT_ANY_BOUNDS:
            return {
                ...state,
                mapFitBounds: action.value
            };
        case type.MAP_MANUALLY_MOVED_OR_ZOOMED:
            return {
                ...state,
                mapManuallyMoved: action.value
            };
        default:
            return state;
    }
};
